import React from 'react';
import Company362MeterDashboard from '../dashboards/Company362MeterDashboard';
import DefaultMeterDashboard from '../dashboards/DefaultMeterDashboard';

/**
 * Main dashboard router component that renders the appropriate dashboard
 * based on the company ID
 */
const MeterDashboardRouter = ({ 
  companyId,
  meters,
  financialYearOptions,
  sourceOptions, 
  isLoading, 
  onRefresh 
}) => {
  // Route to specific dashboard based on companyId
  if (companyId === 362) {
    return (
      <Company362MeterDashboard
        financialYearOptions={financialYearOptions}
        sourceOptions={sourceOptions}
        onRefresh={onRefresh}
      />
    );
  }

  // Default dashboard for all other companies
  return (
    <DefaultMeterDashboard
      financialYearOptions={financialYearOptions}
      sourceOptions={sourceOptions}
      onRefresh={onRefresh}
    />
  );
};

export default MeterDashboardRouter;